<div class="feature-upgrade" [id]="upsellComponentId">

  <div class="img-wrapper" *ngIf="options.staticImgUrl">
    <img [src]='options.staticImgUrl'/>
  </div>

  <!-- <upsell-video-player [options]="options" *ngIf="options.videoUrl"></upsell-video-player> -->

  <div class="feature-description">
    <h4 class="feature-heading">{{options.title}}</h4>
    <ul class="two-col-check-list">
      <li *ngFor="let checklist of options.checkList">
        {{checklist}}
      </li>
    </ul>
 
    <div class="btn-group">
      <button *ngIf="showUpgradeRequestedBtn" class="ui button grey has-box-shadow request-received-btn" disabled i18n>Request Received</button>
      <button *ngIf="showQuoteRequestedBtn" class="ui button grey has-box-shadow request-received-btn" disabled i18n>Request Received</button>
      <button *ngIf="getQuoteRequested" nz-button class="ui button upsell-campaign-cta has-box-shadow" (click)="upgradeToPro('get_quote', getQuoteproductInterest)" i18n>Get a Quote</button>
      <button *ngIf="upgradeNow" nz-button class="ui button upsell-campaign-cta has-box-shadow" (click)="upgradeToPro('upgrade_now', 'ELD Compliance')" i18n>Upgrade Now</button>
      <button *ngIf="showTryForFreeBtn" nz-button class="ui button upsell-campaign-cta has-box-shadow try-for-free-btn" (click)="tryForFree()" i18n>Try For Free</button>
      <a [href]="options.learnMoreUrl" target="_blank" class="ui button white has-box-shadow" i18n>Learn More</a>
    </div>

    <div class="error" *ngIf="showError" i18n>Failed to request upgrade. Please try again in a few minutes.</div>
    <div *ngIf="upgradeNow" class="success-msg" i18n>We will reach out to you within one business day.</div>
  </div>

  <div class="feature-upgrade-footer">
    <p i18n>{isAMAssigned.toString(), select, true {Contact your Motive Account Manager to upgrade.} false {Get in touch with us to upgrade.}}</p>
    <div class="contact-detail">
      <div class="item" *ngIf="isAMAssigned">
        <div class="account-manager">
          <div class="am-name">{{accountManager.name}}</div>
        </div>
      </div>
      <div class="item">
        <!--Temp fix for 000-000-0000, until BE fixes all missing entries-->
        <a href="tel: {{isAMAssigned ? (accountManager.phone === '(000) 000-0000' ? '8554343564' : accountManager.phone) : '8554343564'}}">
          <svg  alt="Mobile phone icon"   width="11" height="15" viewBox="0 0 11 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.289 2v11c0 .552.342 1 .764 1h6.88c.422 0 .764-.448.764-1V2c0-.552-.342-1-.764-1h-6.88c-.422 0-.764.448-.764 1zM.355 2c0-1.105.708-2 1.58-2H9.05c.874 0 1.582.895 1.582 2v11c0 1.105-.708 2-1.582 2H1.936c-.873 0-1.581-.895-1.581-2V2zm4.671 1h-.934V2h.934v1zm1.869 0H5.96V2h.935v1zm-2.803 9h2.803v1H4.092v-1z" fill="#757575"/></svg>
          {{isAMAssigned ? (accountManager.phone === '(000) 000-0000' ? '+1 855-434-3564' : accountManager.phone) : '+1 855-434-3564'}}
        </a>
      </div>
      <div class="item">
        <a target="_blank" href="mailto: {{isAMAssigned ? accountManager.email : 'sales@gomotive.com'}}">
          <svg  alt="Mobile phone icon"   width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.258 1.034l5.38 5.759 5.38-5.76A.878.878 0 0 0 12.778 1H2.5a.878.878 0 0 0-.242.034zm-.66.707c-.021.083-.032.17-.032.259v9c0 .552.418 1 .934 1h10.277c.516 0 .934-.448.934-1V2c0-.09-.01-.176-.031-.259L8.3 7.5a.891.891 0 0 1-1.322 0l-5.38-5.759zM12.776 0c1.032 0 1.868.895 1.868 2v9c0 1.105-.836 2-1.868 2H2.5c-1.032 0-1.868-.895-1.868-2V2c0-1.105.836-2 1.868-2h10.277z" fill="#757575"/></svg>
          {{isAMAssigned ? accountManager.email : 'sales@gomotive.com'}}
        </a>
      </div>
    </div>
  </div>
  <thankyou-modal #thankYouModal></thankyou-modal>
  <trial-activated-modal #trialActivatedModal></trial-activated-modal>
</div>